import Box from "@mui/material/Box";
import type { ReactNode } from "react";
import { useAppCustomStyles } from "../../assets/theme/custom/hooks";

type Props = {
  children: ReactNode;
  borderColor: string;
  backgroundColor: string;
};

/** Shared bordered container for react-data-table-component tables. */
export default function PageDataTablePanel({ children, borderColor, backgroundColor }: Props) {
  const custom = useAppCustomStyles();
  return (
    <Box sx={custom.components.layout.pageDataTablePanel(borderColor, backgroundColor)}>
      {children}
    </Box>
  );
}
